/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Server_Errors_Nofieldstoupdate3Inputs */

const he_server_errors_nofieldstoupdate3 = /** @type {(inputs: Server_Errors_Nofieldstoupdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין שדות לעדכון`)
};

const en_server_errors_nofieldstoupdate3 = /** @type {(inputs: Server_Errors_Nofieldstoupdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fields to update`)
};

/**
* | output |
* | --- |
* | "No fields to update" |
*
* @param {Server_Errors_Nofieldstoupdate3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const server_errors_nofieldstoupdate3 = /** @type {((inputs?: Server_Errors_Nofieldstoupdate3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Server_Errors_Nofieldstoupdate3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_server_errors_nofieldstoupdate3(inputs)
	return en_server_errors_nofieldstoupdate3(inputs)
});
export { server_errors_nofieldstoupdate3 as "server_errors_noFieldsToUpdate" }